import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { TreatmentsHero } from '../components/treatments/TreatmentsHero';
import { TreatmentCategory } from '../components/treatments/TreatmentCategory';
import { TreatmentsCTA } from '../components/treatments/TreatmentsCTA';
const categories = [{
  id: 'injectables',
  number: '01',
  title: 'INJECTABLES',
  treatments: ['Wrinkle Relaxers', 'Dermal Fillers', 'PDO Threads', 'Sculptra', 'Fat Dissolving Injections'],
  image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=700&h=500&fit=crop',
  variant: 'light' as const,
  reversed: false
}, {
  id: 'lasers',
  number: '02',
  title: 'LASERS',
  treatments: ['Laser Hair Removal', 'SkinTyte Laser', 'BBL Forever Young + Forever Clear', 'ClearSilk Laser Facial', 'Clear + Brilliant', 'Halo Skin Resurfacing', 'DiVa Vaginal Rejuvenation'],
  image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=700&h=500&fit=crop',
  variant: 'dark' as const,
  reversed: true
}, {
  id: 'body',
  number: '03',
  title: 'BODY',
  treatments: ['Cooltone', 'CoolSculpting Elite', 'Weight Loss for Men', 'Weight Loss for Women'],
  image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=700&h=500&fit=crop',
  variant: 'light' as const,
  reversed: false
}, {
  id: 'skin',
  number: '04',
  title: 'SKIN',
  treatments: ['Potenza Radio Frequency Microneedling', 'Traditional Microneedling', 'Chemical Peels', 'Hydropower Facial', 'Korean Mesotherapy', 'Microblading', 'Dermaplaning & Waxing'],
  image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=700&h=500&fit=crop',
  variant: 'dark' as const,
  reversed: true
}, {
  id: 'medical',
  number: '05',
  title: 'MEDICAL',
  treatments: ['IV Infusions & Injections', 'Bioidentical Hormone Replacement Therapy', 'Testosterone Replacement Therapy', 'Ladies Intimate Shot (O-SHOT)', 'Performance Enhancement Shot', 'Hair Restoration for Men', 'Hair Restoration for Women'],
  image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=700&h=500&fit=crop',
  variant: 'light' as const,
  reversed: false
}];
export function TreatmentsPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2653">
      <Navigation data-id="element-2654" />
      <main data-id="element-2655">
        <TreatmentsHero data-id="element-2656" />
        {categories.map(cat => <TreatmentCategory key={cat.id} {...cat} data-id="element-2657" />)}
        <TreatmentsCTA data-id="element-2658" />
      </main>
      <Footer data-id="element-2659" />
    </div>;
}